<template>
  <div class="container">
    <app-header title="我的发票"/>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(index)" :class="activeTag==index ? 'active':''">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="recharge" v-for="(item,index) in list" @click="details(item.id)">
      <div class="rechargeme">
        <div class="title">订单编号：{{item.orderNo}}</div>
        <div class="status" v-if="item.status==0" style="background: #FE003B;color: #ffffff">未开</div>
        <div class="status" v-if="item.status==1">已开</div>
      </div>
      <div class="eaprice">￥{{item.ttlMoney}}</div>
      <div class="redate">{{item.name}}</div>
      <!--<div class="redate">电话号码：{{item.tel}}</div>-->
    </div>
    <empty v-if="list.length==0"/>
  </div>

</template>

<script>
import { queryShopTicketList } from '@/api/invoce/index.js'
export default {
  name: 'Invoice',
  data() {
    return {
      show: true,
      activeTag: 0,
      tabList: ['全部', '增值税专票', '增值普票'],
      list: []
    }
  },
  created() {
    this._queryShopTicketList()
  },
  methods: {
    _queryShopTicketList() {
	  var user = localStorage.getItem('userInfo')
	  user = JSON.parse(user)
      const params = {
        isWait: 1,
        uid: user.id,
        type: this.activeTag-1
      }
      queryShopTicketList(params).then((res) => {
        if (res.success) {
		      this.list = res.data
        }
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index == 0) {
        this.show = true
      } else {
        this.show = false
      }
      this._queryShopTicketList()
    },
    details(id) {
      this.$router.push({
        path: '/details',
        query:{
          id: id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .recharge{
      padding: 12px;
      border-top: 2px solid #EDEDED;
      border-bottom: 2px solid #EDEDED;
      .rechargeme{
        display: flex;
        justify-content: space-between;
        .title{
          font-size:14px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:20px;
          color:rgba(136,137,136,1);
          opacity:1;
        }
        .status{
          width:36px;
          height:18px;
          background:rgba(136,137,136,1);
          opacity:1;
          border-radius:2px;
          font-size: 12px;
          text-align: center;
          line-height: 18px;
        }
      }
      .eaprice{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        opacity:1;
        margin-top: 5px;
        text-align: right;
        margin-right: 12px;
        color:rgba(51,51,51,1);
      }
      .redate{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/invoice/index.vue